import React from "react";
import './Chisiamo.css'
import { Container, Row, Col } from "react-bootstrap";
import {MyAnimatedTypo,MyAnimatedTypo2} from "../Moving";
import imageUrl1 from "../../Assets/servizi4.png";
import imageUrl2 from "../../Assets/servizi5.png";
import imageUrl3 from "../../Assets/servizi6.png";
import imageUrl4 from "../../Assets/servizi11.png";

function Chisiamo() {
  return (
    <section>
      <Container fluid className="home-section" id="chisiamo">
        <Container className="Chisiamo-content">  
            <Row md={7} className="Chisiamo-header">
              <h1 style={{ paddingTop: 40 }}>
              CHI SIAMO
              </h1>
            </Row>
            <div className="Chisiamo-rainbow">
            <Row> 
              <Row>
                <Col md={8} >
                  Mi chiamo Fabio Bevilacqua e ho deciso di intraprendere il percorso di amministratore di condominio
                  tramite l’Associazione Nazional-europea Amministratori d'Immobili (<b>ANAMMI</b>),
                  a seguito del percorso universitario in materie economiche, più precisamente in “Direzione d’impresa marketing e strategia”,
                  e della pluriennale esperienza in ambito industriale
                </Col>
                <Col md={4} >
                    <div className= "Chisiamo-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                          <img src={imageUrl1} alt= ''/>
                    </div>
                </Col>
              </Row>
              <Row className="Chisiamo-change1">
                <Col md={4} >   
                  <div className= "Chisiamo-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                        <img src={imageUrl2} alt= ''/>
                  </div>
                </Col>
                <Col md={8} >
                  Lo <b>STUDIO B.A.E.S.</b> nasce con l’intento di voler modernizzare la figura dell’amministratore condominiale, 
                  mettendo al servizio delle singole famiglie un <b>SERVIZIO PROFESSIONALE</b>, <b>EFFICIENTE</b>, <b>CONNESSO</b> e sempre di più vicino alle <b>SINGOLE ESIGENZE</b>.
                </Col> 
              </Row>
              <Row className="Chisiamo-change2">
                <Col md={8} >
                  Lo <b>STUDIO B.A.E.S.</b> nasce con l’intento di voler modernizzare la figura dell’amministratore condominiale, 
                  mettendo al servizio delle singole famiglie un <b>SERVIZIO PROFESSIONALE</b>, <b>EFFICIENTE</b>, <b>CONNESSO</b> e sempre di più vicino alle <b>SINGOLE ESIGENZE</b>.
                </Col>
                <Col md={4} >   
                  <div className= "Chisiamo-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                        <img src={imageUrl2} alt= ''/>
                  </div>
                </Col>
              </Row>
              <Row>
                <Col md={8} >
                  Il <b>PRINCIPALE OBBIETTIVO</b> del nostro lavoro è il raggiungimento di un sistema <b>WIN-WIN</b>, dove tutte le parti coinvolte risultano soddisfatte,
                  attraverso un <b>RAPPORTO SINCERO</b> e l’attuazione di scelte ottimali sia in termini economici che di qualità
                </Col> 
                <Col md={4} >   
                  <div className= "Chisiamo-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                        <img src={imageUrl3} alt= ''/>
                  </div>
                </Col>
              </Row>   
              <Row className="Chisiamo-change1">
                <Col md={4} >   
                  <div className= "Chisiamo-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                        <img src={imageUrl4} alt= ''/>
                  </div>
                </Col>
                <Col md={8} >
                 Lo studio <b>BAES</b> è iscritto all’associazione <b>ANAMMI</b> con il codice <b>BP39</b> e partecipa attivamente ai continui corsi di formazione ed eventi per poter avere una conoscenza completa
                 in materia e offrire un miglior servizio!
                </Col> 
              </Row>
              <Row className="Chisiamo-change2">
                <Col md={8} >
                 Lo studio <b>BAES</b> è iscritto all’associazione <b>ANAMMI</b> con il codice <b>BP39</b> e partecipa attivamente ai continui corsi di formazione ed eventi per poter avere una conoscenza completa
                 in materia e offrire un miglior servizio!
                </Col>
                <Col md={4} >   
                  <div className= "Chisiamo-image-container"  style={{ paddingTop: 10, paddingBottom :10 }}>
                        <img src={imageUrl4} alt= ''/>
                  </div>
                </Col>
              </Row> 
            </Row>           
            </div>

        </Container>  
      </Container>
    </section>
  );
}

export default Chisiamo;
